import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { Table, TableBody, TableContainer, TableHead } from "@mui/material";
import { useTranslation } from "react-i18next";
import React, { Fragment } from "react";
import { AlertSpg, isArrayEmpty, isArrayNotEmpty, TableButton } from "@duosoftbg/nacid-components";
import HomePageCategoryRow from "./HomePageCategoryRow";
import EditCategoryDialog from "./dialog/category/EditCategoryDialog";
import useAppDispatch from "../../../../../hooks/redux/base/useAppDispatch";
import { openEditModal } from "../../../../../store/redux/slice/ComponentsControl/homePageCategoryControl";
import { homePageCategorySection } from "../../../../../utils/constants";
import { homePageCategoryCreationInitialValues } from "../../../../../init/homePageCategoryCreationInitialValues";
import DeleteCategoryDialog from "./dialog/category/DeleteCategoryDialog";
import EditCategoryLinkDialog from "./dialog/link/EditCategoryLinkDialog";
import DeleteCategoryLinkDialog from "./dialog/link/DeleteCategoryLinkDialog";
const HomePageCategoryList = ({ categories }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  return (
    <Fragment>
      <EditCategoryDialog />
      <DeleteCategoryDialog />
      <EditCategoryLinkDialog />
      <DeleteCategoryLinkDialog />
      <TableContainer>
        <Table aria-label="collapsible table">
          <TableHead>
            <TableRow>
              <TableCell style={{ width: 35 }} />
              <TableCell>{t("l.table.head.description")}</TableCell>
              <TableCell>{t("l.table.head.descriptionEn")}</TableCell>
              <TableCell>{t("l.table.head.position")}</TableCell>
              <TableCell align="right">
                <TableButton
                  type={"create"}
                  onClick={() => {
                    dispatch(
                      openEditModal({
                        section: homePageCategorySection.category,
                        object: homePageCategoryCreationInitialValues,
                      }),
                    );
                  }}
                />
              </TableCell>
            </TableRow>
          </TableHead>
          {isArrayNotEmpty(categories) && (
            <TableBody>
              {categories.map((category) => (
                <HomePageCategoryRow key={category.id} category={category} />
              ))}
            </TableBody>
          )}
        </Table>
        {isArrayEmpty(categories) && <AlertSpg severity="info">{t("m.empty.list")}</AlertSpg>}
      </TableContainer>
    </Fragment>
  );
};

export default HomePageCategoryList;
